// extracted by mini-css-extract-plugin
export var readonly = "_i3-1";
export var star = "_i3-0";